module.exports = __webpack_public_path__ + "static/media/loewy-cover.2c8dcb83.jpg";